import React, { useState } from 'react';
import { Field } from 'formik';
import * as moment from 'moment';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import styled from 'styled-components';


const DatePicker = ({name, disabled, editResponse, callBackFun, selectedDate}) => {
  let dateSet = new Date();
  let date = new Date();
  let plusFourDays = date.setDate(date.getDate() + 4);
  let minDOBirth = new Date();
  let maxDOBirth = '';
  
  const [onChangeActive, setOnChangeActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleDateChange = (name, setFieldValue, setFieldError, date,meta) => {    
    if(new Date().setDate(new Date(minDOBirth).getDate() - 1) <= date){     
      callBackFun()
      onChange(date)
      setOnChangeActive(false)
      setErrorMessage()
      setFieldValue(name, moment(date).format(FORMAT));
    }else{
      setOnChangeActive(true)
      if(date === " Invalid Date" || date === "Invalid Date" || date === " Invalid Date "){
        setErrorMessage("Invalid Date")
      }else{
        callBackFun("Date should not be before minimal date")
        setErrorMessage("Date should not be before minimal date")
      }      
    }
  };

  let plusTwentyTwo = new Date().setDate(new Date().getDate() + 22);
  let currentDate = new Date();
  minDOBirth = currentDate.setDate(currentDate.getDate());
  dateSet= new Date(currentDate)

  maxDOBirth = plusTwentyTwo

  let editDate = new Date()
  
  if(editResponse){//new Date(editResponse.requestDeliveryDate).setDate(new Date(editResponse.requestDeliveryDate).getDate()
    // let plusTwo = moment(new Date().setDate(new Date(editResponse?.loadDetails?.requestDeliveryDate).getDate()))
    // plusFourDays = new Date(plusTwo)

    let currentDate = moment(new Date(editResponse?.loadDetails?.requestDeliveryDate * 1000).toLocaleString()).format(FORMAT)
    plusFourDays = new Date(currentDate)
  }
  
  const [value, onChange] = useState(plusFourDays);
  return (
    <div>
      <Field name={name}>
        {({ form, meta }) => {
          return (
            <DatePickerWrapper>
              <div className='custom-date-piker'>
                <div
                  className={`file-input-wrapper ${meta.touched && meta.error ? 'error' : ''
                    }`}
                >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      // disabled={disabled ? disabled : false}
                      minDate={minDOBirth}
                      maxDate={maxDOBirth}
                      name={name}
                      margin="normal"
                      id="date-picker-dialog"
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      disabled={disabled}
                      // value={editResponse && onChangeActive ===false? editDate : value}
                      value={selectedDate || value}
                      // highlightDates={[
                      //   {
                      //     "highlighted-class": daysHighlighted.map((day, index) => {
                      //       day.setDate(day.getDate() + index)
                      //       return new Date(day)
                      //     }
                      //     )
                      //   }
                      // ]}
                      onChange={(date) => {
                        // if(props?.editResponse){}
                        //form.setFieldValue(name,moment(date).format(FORMAT))
                        handleDateChange(name, form.setFieldValue, form.setFieldError, date,meta)
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />

                  </MuiPickersUtilsProvider>

                </div>
              </div>
              {/*  style={{"position": "absolute", "margin": "-35px 0px"}} */}
              {/* {meta.error || onChangeActive && <p name={name + 'Error'} className="error-message">{meta.error?meta.error:errorMessage}</p>} */}
            </DatePickerWrapper>
          );
        }}
      </Field>
    </div>
  );
};
export default DatePicker;

const DatePickerWrapper = styled.div`
  .MuiFormControl-marginNormal {
    margin: 0;
  }
`